module.exports = __webpack_public_path__ + "img/icon_folder.6096cb50.svg";